/**
 * File: WeblinkPreviewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class WeblinksPreviewController {
    // @ngInject
    constructor($scope, $state, $rootScope, $sce, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {}

        let userId = localStorageService.get("user_id")
        let planId = $state.params.planId;
        let plan = localStorageService.get("currentPlan")
        console.log(plan)
        let authoring = localStorageService.get("authoringData")
        let resourceId = $state.params.resourceId;

        var loadTemplate = () => {
            if (plan) {
                $scope.resource = _.find(plan.resources, function(res) {
                    return res._id === resourceId
                })

                if ($scope.userPrev.viewKhanAcademy != undefined && $scope.userPrev.viewKhanAcademy.read && ($scope.userPrev.addKhanAcademyLinks == undefined || ($scope.userPrev.addKhanAcademyLinks && !$scope.userPrev.addKhanAcademyLinks.create)) && ($scope.userPrev.approveKhanAcademyLinks == undefined || ($scope.userPrev.approveKhanAcademyLinks && !$scope.userPrev.approveKhanAcademyLinks.create))) {
                    try {
                        var data = {
                            resource: {
                                type: $scope.resource.type,
                                subject_id: authoring.subject_id,
                                class_id: authoring.class_id,
                                curriculum_id: authoring.curriculum_id,
                                batch_id: authoring.batch_id,
                                session_id: authoring.session_id,
                                school_id: authoring.school_id,
                                theme_id: plan.theme_id,
                                plan_id: planId,
                                progress_data: {
                                    _id: resourceId,
                                    title: $scope.resource.title
                                }
                            },
                            user_id: userId
                        }
                        authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, () => {})
                    } catch (ex) {}

                }
                if ($scope.resource) {
                    if ($scope.resource.url) {
                        $scope.isAvailable = true
                        $scope.src = $scope.resource.url;
                        var video_id = $scope.src.split('v=')[1].split('&')[0];
                        $scope.src = $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + video_id + "?modestbranding=1;&rel=0");
                    }
                }
                _.defer(() => {
                    $scope.$apply();
                });
            }
        }
        /*Roles and Privilege*/
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "khanAcademy"
        })
        $scope.userPrev = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userPrev[tpObj.feature_id] = user_access;
            })
            loadTemplate()
        }
    };
}

export default WeblinksPreviewController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/resources/khanAcademyPreview.js